import { useState, useEffect } from 'react'
import api, { ILocationCapacity } from '@api'
import { useShouldReload } from '@hooks/reloadContext'

export function useLocationCapacities() {
  const [capacities, setCapacities] = useState<ILocationCapacity[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const shouldReload = useShouldReload()

  useEffect(() => {
    api.company.locationCapacities.fetch().then((locationCapacities) => {
      setCapacities(locationCapacities)
      setIsLoading(false)
    })
  }, [shouldReload.locationCapacities])

  return { capacities, isLoading }
}
